// Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared/shared.module';
// Pages
import { RegistrationLayoutPageComponent } from './pages/registration-layout-page/registration-layout-page.component';
import { RegistrationEntryPageComponent } from './pages/registration-entry-page/registration-entry-page.component';
import { RegistrationSuccessPageComponent } from './pages/registration-success-page/registration-success-page.component';
import { RegistrationPaymentCallbackPageComponent } from './pages/registration-payment-callback-page/registration-payment-callback-page.component';
// Shared
import { RegistrationNavigationComponent } from './components/registration-navigation/registration-navigation.component';
// Steps
import { RegistrationPersonalDetailsComponent } from './pages/steps/registration-personal-details/registration-personal-details.component';
import { RegistrationTermsAndConditionsComponent } from './pages/steps/registration-terms-and-conditions/registration-terms-and-conditions.component';
import { RegistrationProviderAuthenticationComponent } from './pages/steps/registration-provider-authentication/registration-provider-authentication.component';
import { RegistrationProviderTranslationComponent } from './pages/steps/registration-provider-translation/registration-provider-translation.component';
import { RegistrationShippingAddressComponent } from './pages/steps/registration-shipping-address/registration-shipping-address.component';
import { RegistrationAddChildrenComponent } from './pages/steps/registration-add-children/registration-add-children.component';
import { RegistrationMembershipOptionsComponent } from './pages/steps/registration-membership-options/registration-membership-options.component';
import { RegistrationPaymentComponent } from './pages/steps/registration-payment/registration-payment.component';
import { RegistrationOperatorNameComponent } from './pages/steps/registration-operator-name/registration-operator-name.component';
import { RegistrationChildQuestionsComponent } from './pages/steps/registration-child-questions/registration-child-questions.component';
import { RegistrationFailurePageComponent } from './pages/registration-failure-page/registration-failure-page.component';
import { RegistrationChooseMembershipOptionTypeComponent } from './pages/steps/registration-choose-membership-option-type/registration-choose-membership-option-type';
import { GuardianModule } from '../guardian/guardian.module';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { CountryAndRegionsModule } from '@fgb/portal-component-library/src/lib/shared/country-and-regions';
//import { RegistrationChooseRegStepComponent } from './pages/steps/registration-choose-reg-step/registration-choose-reg-step.component';
import { TermsAndConditionsModule } from '@fgb/portal-component-library/src/lib/club/terms-and-conditions';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { RegistrationNavigationModule } from '@fgb/portal-component-library/src/lib/registration';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
//import { RegisterLogoPipe } from 'src/app/shared/pipes/register-logo.pipe';
import { SelectCountryModule } from '@fgb/portal-component-library/src/lib/shared/select-country';
import { SelectRegionModule } from '@fgb/portal-component-library/src/lib/shared/select-region';
import { LayoutModule } from 'src/app/modules/layouts/layout.module';
//import { ButtonLoading } from 'src/app/shared/button-loading/button-loading.component';
@NgModule({
  declarations: [
    RegistrationLayoutPageComponent,
    RegistrationEntryPageComponent,
    RegistrationSuccessPageComponent,
    RegistrationNavigationComponent,
    RegistrationPaymentCallbackPageComponent,
    // Steps
    RegistrationPersonalDetailsComponent,
    RegistrationTermsAndConditionsComponent,
    RegistrationProviderAuthenticationComponent,
    RegistrationProviderTranslationComponent,
    RegistrationShippingAddressComponent,
    RegistrationAddChildrenComponent,
    RegistrationMembershipOptionsComponent,
    RegistrationPaymentComponent,
    RegistrationOperatorNameComponent,
    RegistrationChildQuestionsComponent,
    RegistrationFailurePageComponent,
    RegistrationChooseMembershipOptionTypeComponent,
    //RegistrationChooseRegStepComponent,
  ],
  imports: [
    NgbModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ErrorsModule,
    ReactiveFormsModule,
    CountryAndRegionsModule,
    DirectivesModule,
    FGBSharedModule,
    SharedModule,
    GuardianModule,
    TermsAndConditionsModule,
    RegistrationNavigationModule,
    LoadingModule,
    //RegisterLogoPipe,
    SelectCountryModule,
    SelectRegionModule,
    LayoutModule,
   // ButtonLoading
  ],
  exports: [
    RegistrationLayoutPageComponent,
    RegistrationEntryPageComponent,
    RegistrationSuccessPageComponent,
    //RegistrationChooseRegStepComponent,
  ],
})
export class RegistrationModule {}
